export class User{
    Id:string;
    FirstName : string;
    CompanyId : number;
    LastName : string;
    Email : string;
    PhoneNumber : string;
    Type : string;
    UserId : string;
    RoleName : string;
    RoleId : string;
    UserName : string;
    Password : string;
    IsLockedOut : boolean;
    ActionType : string;
}

export class UserList{
    FirstName : string;
    CompanyId : number;
    LastName : string;
    Email : string;
    PhoneNumber : string;
    Type : string;
    Id : string;
    RoleName : string;
    RoleId : string;
    UserName : string;
    Password : string;
}

export interface ListItem {
    UserId: string;
  }

  export interface Access {
    Id: number;
    Name: string;
}
